/* eslint-disable */

import { useState, useEffect } from "react";
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage";
import { fetchLabEnteryCall, fetchLabEnteryPrintCall } from "./lanEnteryService";
import { useNavigate } from "react-router-dom";


const useLabEnteryHook = (initialState) => {
    const navigate = useNavigate();
    const [labEnteryTableState, setLabEnteryState] = useState(initialState);

    const labEnteryTable = async () => {
        try {
            let { data: { result }, status } = await fetchLabEnteryCall();

            if (status === 200) setLabEnteryState(result)
        }
        catch (e) {
            errorToast("Failed To fetch Department")
        }

    }

    const handleGetRowId = (e) => {
        return e?.billHeaderID

    }
    useEffect(() => {
        labEnteryTable()
    }, [])

  

    const handleOnCellClick = async (params, e) => {
        // e.stopPropagation()
        if (params?.field === "billNumber") {
            navigate("/pathology/add-lab-entery", { state: { rowData: params?.row } })
          
        }

    }

    return {
        labEnteryTableState,
        handleGetRowId,
        handleOnCellClick,

    }


};


export default useLabEnteryHook;


